import { Button, InputAdornment, TextField, Typography } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import AddIcon from "@mui/icons-material/Add";
import excel from "../../Admin/assets/icons/excel_pic.svg";
import pdf from "../../Admin/assets/icons/pdf_pic.svg";
import DownloadIcon from '@mui/icons-material/Download';

const PageHeader = ({ setOpenDialog, setOpenDialogcatalogue, title, files, search, showButton = true, setSearch, isAddToCartPage, btn, btn2, Download }) => {
  return (
    <div className="catalogue-title">
      <div className="catalogue-text">
        <Typography variant="h5">{title.name}</Typography>
        <Typography variant="h6">{title.subheading}</Typography>
      </div>
      <div className="catalogue-menu">
        {search ? null : (
          <TextField
            placeholder={title.search}
            type="search"
            variant="outlined"
            onChange={(e) => { setSearch(e.target.value) }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              ),
            }}
          />
        )}
        {files && (
          <div className="excel-pdf">
            <div className="excel" onClick={Download}>
              <img src={excel} alt="excel" /> <p>Download</p> <DownloadIcon />
            </div>
            {/* <div className="pdf">
              <img src={pdf} alt="pdf" />
            </div> */}
          </div>
        )}
        {showButton && (
          <>
            {isAddToCartPage ? (
              <>
                <Button endIcon={<AddIcon />} onClick={() => setOpenDialog(true)}>
                  {btn}
                </Button>
                <Button endIcon={<AddIcon />} onClick={() => setOpenDialogcatalogue(true)}>
                  {btn2}
                </Button>
              </>
            ) : title.button && (
              <Button endIcon={<AddIcon />} onClick={() => setOpenDialog(true)}>
                {title.button}
              </Button>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default PageHeader;
